<template>
    <modal size="lg" @close="reset(); $emit('close')" :height-max="true" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Company Tax Registration</h3>
        </template>

        <slot>
            <tax-registration-form
                ref="companyTaxRegistrationForms"
                :tax-id="taxRegistration.tax.id"
                :jurisdiction-id="taxRegistration.tax.jurisdiction_id"
                :tax-type="taxRegistration.tax.type"
                :additional-fields="taxRegistration.tax.current_version.employer_specific_fields"
                :value="formData"
                :disable-use-for-all="true"
            />
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import TaxRegistrationForm from './TaxRegistrationForm'

export default {
    props: ['taxRegistration', 'client', ],
    mixins: [FormMixin, ModalMixin],
    components: {TaxRegistrationForm, },
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    methods: {
        makeFormData() {
            const data = {
                filing_id: this.taxRegistration.filing_id,
                is_exempt: this.taxRegistration.is_exempt,
            }

            this.taxRegistration.tax.current_version.employer_specific_fields.forEach(field => {
                const answer = this.taxRegistration.company_tax_registration_additional_values.find(val => val.name == field.name)
                data[field.name] = answer.raw_value
            })

            return data
        },
        getFormData() {
            return this.$refs.companyTaxRegistrationForms.getFormData()
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            const url = `/clients/${this.client.id}/settings/tax-registrations/${this.taxRegistration.id}`
            this.$api.put(url, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        }
    }
}
</script>
